function NavBtn({src, text, activated, activate})
{
    return (
        <a
            className={"sidebar-options flexColumn flexMiddle flexCenter" + ( activated ? " option-active" : "")}
            onClick={() => activate()}
        >
            <img src={src} className="picto-sidebar sidebar-txt" alt="" />
            <div className="texte-options">{text}</div>
        </a>
    )
}

export default NavBtn;